/**
 * A Test Specification's sub-category is optional (ADR-0009). A blank one means
 * "this spec has no sub-category tier" — its tests render directly under their
 * Category, with no sub-category node at all.
 *
 * Every consumer that groups specs by sub-category (the spec editor, reports,
 * the Test Creator, exports) must share this sentinel and normalizer. Grouping
 * code that invents its own check has dropped tier-less specs entirely before
 * (QA 307.07).
 *
 * Named `subcategory-tier`, not `subcategory`: the latter collides with
 * SubCategory.tsx on case-insensitive filesystems, so a sibling test's
 * `vi.mock('../SubCategory')` would swallow this module.
 */

/** Sentinel key for "no sub-category tier". Never a real sub-category name, never a heading. */
export const NO_SUBCATEGORY = '';

/** Maps a raw sub-category (null, blank, or padded) onto its grouping key. */
export function normalizeSubcategoryKey(subcategory: string | null | undefined): string {
    return subcategory?.trim() ? subcategory.trim() : NO_SUBCATEGORY;
}

/** True when the spec has a real, nameable sub-category worth rendering as a tier. */
export function hasSubcategoryTier(subcategory: string | null | undefined): boolean {
    return normalizeSubcategoryKey(subcategory) !== NO_SUBCATEGORY;
}
